












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class Presubscriptions extends Vue {
    @Prop({ required: true }) getDateFormat!: () => {};
    @Prop({ required: true }) refreshTrigger!: boolean
    @Prop({ required: false }) providerId!: number
    @Prop({ required: true }) carrierId!: number
    @Prop({ required: true }) formData!: { msisdn: string; provider: null|number }

    localLoading = false

    tables = {
        presubscriptions: {
            data: [],
            columns: [
                {
                    text: 'MSISDN',
                    value: 'presubscriptionMsisdn'
                },
                {
                    text: 'MDS',
                    value: 'mdsId'
                },
                {
                    text: 'Portal',
                    value: 'presubscriptionPortal'
                },
                {
                    text: 'Adnetwork',
                    value: 'presubscriptionAdnetwork'
                },
                {
                    text: 'Pixel Adnetwork',
                    value: 'presubscriptionPixel'
                },
                {
                    text: 'Pub',
                    value: 'presubscriptionPub'
                },
                {
                    text: 'Process At',
                    value: 'presubscriptionProcessAt'
                },
                {
                    text: 'Modified',
                    value: 'dateModified'
                },
                {
                    text: 'Created',
                    value: 'dateCreated'
                },
                {
                    text: 'Provider',
                    value: 'providerId.providerName'
                },
                {
                    text: 'Product',
                    value: 'productId.productName'
                },
                {
                    text: 'Shortcode',
                    value: 'shortcodeId.shortcode'
                }
            ]
        }
    }

    @Watch('refreshTrigger')
    refreshHandler () {
        this.getPresubscriptions()
    }

    mounted () {
        this.getPresubscriptions()
    }

    getPresubscriptions () {
        return new Promise(resolve => {
            this.localLoading = true

            let localProvider = JSON.parse(JSON.stringify(this.providerId))
            if (!Array.isArray(localProvider)) localProvider = localProvider ? [localProvider] : []

            this.$store.dispatch('getPresubscriptions', {
                carrierId: this.carrierId,
                msisdn: this.formData.msisdn,
                providerId: localProvider
            })
                .then(resp => {
                    if (resp?.status === 200) {
                        const presubscriptions = this.$store.state.MonitorStore.presubscriptions
                        this.tables.presubscriptions.data = presubscriptions
                        this.localLoading = false
                        this.$emit('localLoadingEnd')
                        resolve()
                    }
                })
        })
    }
}

